import { render } from "./CustomRingPlayer.vue?vue&type=template&id=53183568&scoped=true"
import script from "./CustomRingPlayer.vue?vue&type=script&lang=js"
export * from "./CustomRingPlayer.vue?vue&type=script&lang=js"

import "./CustomRingPlayer.vue?vue&type=style&index=0&id=53183568&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53183568"]])

export default __exports__